import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Back from '../Back/Back'

import styles from './Stub.css'

const propTypes = {
    message: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,

    /**
     * This prop is used to hide close button
     */
    hideClose: PropTypes.bool,

    closeCaption: PropTypes.node.isRequired,
    onCloseClick: PropTypes.func.isRequired,

    /**
     * This prop used only for demonstration needs, so it is not needed in documentation
     *
     * @ignore
     */
    isDemo: PropTypes.bool,
}

class Stub extends React.PureComponent {
    render() {
        const classNameBase = classNames(styles.base, {
            [styles.isDemo]: this.props.isDemo,
        })

        return(
            <div className={classNameBase}>
                {
                    !this.props.hideClose &&
                    <div className={styles.close}>
                        <Back
                            caption={this.props.closeCaption}
                            onClick={this.props.onCloseClick}
                            side="right"
                            type="close"
                        />
                    </div>
                }
                <div className={styles.holder}>
                    <p className={styles.title}>{this.props.title}</p>
                    <p className={styles.message}>{this.props.message}</p>
                </div>

            </div>
        )
    }
}

Stub.propTypes = propTypes

export default Stub



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Stub/Stub.jsx